























import Vue from 'vue'
import Component from 'vue-class-component'
import { LMap, LTileLayer, LMarker, LCircle, LIcon } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import { ISettingsItem, IUserInfo } from '@app/componentlib/common/types/JobSearchTypes'
import { ICoordsFromAddressParams, ICountry, IMapInformation, IRegion } from '@app/componentlib/common/types/LocationTypes'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'

@Component<LeafletMap>({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LCircle,
    LIcon
  },
  props: {
    radius: Number,
    userInfo: Object,
    isActive: Boolean,
    countryToInit: String,
    settings: Object
  },
   watch: {
    isActive: {
      handler() {
        this.setMapPoints()
      }
    }
  }
})

export default class LeafletMap extends Vue {
  /**
   * Props variables
   */
  userInfo: IUserInfo | undefined
  isActive: boolean | undefined
  countryToInit: string | undefined
  settings: ISettingsItem | undefined

  /**
   * Component state variables
   */
  mapUrl: string = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  centerPoint: number[] = []
  markerPoint: number[] = []
  zoom: number = 8
  radius: number = 50
  isDraggable: boolean = false
  interactive: boolean = false
  isUsingMap: boolean = false

  /**
   * Lifecycle
   */
  async mounted() {
    if (
      (this.userInfo !== undefined &&
      this.selectedCountry.countryCode === this.userInfo.country) &&
      (this.countryToInit === undefined ||
      this.countryToInit === '')
    )
      await this.getCoordinatesFromAddress(this.userInfo!.address.toString(), this.userInfo!.zipCode.toString(), this.userInfo!.country)

    await this.initMapInfo()
  }

  /**
   * Getters
   */
  get mapInformation (): IMapInformation {
    return LocationModule.mapInformation
  }

  get selectedCountry (): ICountry {
    return LocationModule.selectedCountry
  }

  get location (): IRegion {
    return LocationModule.locations[0]
  }


  /**
   * Methods
   */
  initMapInfo() {
    // Decontruct mapinformation
    const { Zoom, Radius, IsDraggable, Interactive } = this.mapInformation

    this.setMapPoints()

    this.zoom = Zoom || 8
    this.radius = Radius || 25
    this.isDraggable = IsDraggable || false
    this.interactive = Interactive || false
  }

  setMapPoints() {
    const { Lat, Lng } = this.mapInformation

    // Sets where the map is centeret at
    this.centerPoint = [Lat || 0, Lng || 0]

    // Sets where the marker is located at, should be the same place as centerpoint
    this.markerPoint = [Lat || 0, Lng || 0]

    this.getLocationFromCordinates(Lat, Lng, false)
  }

  mapEvent(event: any): void {
    if (this.interactive === true && this.isUsingMap === false) {
      this.setPointsFromEvent(event.latlng.lat, event.latlng.lng)
    }
  }

  mapDragged(event: any): void {
    if (this.interactive === true && this.isDraggable === true && this.isUsingMap === false) {
      this.setPointsFromEvent(event.target._latlng.lat, event.target._latlng.lng)
    }
  }

  setPointsFromEvent(lat: number, lon: number) {
    this.markerPoint = [lat, lon]
    this.getLocationFromCordinates(lat, lon, true)
  }

  async getLocationFromCordinates(lat: number, lng: number, isClick: boolean) {
    if (lat && lng && this.isUsingMap === false) {
      this.isUsingMap = true
      await LocationModule.GetAddressFromCoordinates({lat: lat, lon: lng}).then((data) => {
        if (data !== undefined && isClick) LocationModule.setLocation([data])
      })
      this.searchFromMapClick(isClick)
      this.isUsingMap = false
    }
  }

  async getCoordinatesFromAddress(address: string, postal: string, country: string) {
    // Make sure postal exists, since its necessary to find a location
    if (postal !== "" && /\d/.test(postal)) {
      let params = {
        address: address,
        postal: postal,
        country: country
      } as ICoordsFromAddressParams

      await LocationModule.getCoordinatesFromAddress(params)
      if (this.isActive === true)
        await this.getLocationFromCordinates(LocationModule.mapInformation.Lat, LocationModule.mapInformation.Lng, false).then((data) => {
          if (data !== undefined) LocationModule.setLocation([data])
        })
    } else {
      if (this.isActive === true)
        await this.getLocationFromCordinates(this.markerPoint[0], this.markerPoint[1], false).then((data) => {
          if (data !== undefined) LocationModule.setLocation([data])
        })
    }
  }

  searchFromMapClick(isClick: boolean) {
    if (isClick)
      this.$emit('searchFromMapClick')
  }
}
